import * as React from 'react';
import styled from '@emotion/styled';

const Component: React.FCX = ({ children, className }) => <div className={className}>{children}</div>;

const StyledComponent = styled(Component)`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  padding: 2em;
`;

export default StyledComponent;
